// Words every screen uses the same way. Anything with a context (a gender, a count, a subject) goes in its screen's file
const en = {
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  remove: 'Remove',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  ok: 'OK',
  loading: 'Loading...',
  optional: 'Optional',
  /** The title of a confirmation dialog that has none */
  confirmTitle: 'Are you sure?',
  /** The title of an alert that has none */
  alertTitle: 'Message',
};

const fr: typeof en = {
  cancel: 'Annuler',
  save: 'Enregistrer',
  delete: 'Supprimer',
  remove: 'Retirer',
  edit: 'Modifier',
  close: 'Fermer',
  back: 'Retour',
  ok: 'OK',
  loading: 'Chargement...',
  optional: 'Facultatif',
  confirmTitle: 'Êtes-vous sûr\u00a0?',
  alertTitle: 'Message',
};

const messages = { en, fr };
export default messages;
